import { Routes } from "@angular/router";
import { SchedulerAlertsReportComponent } from "./scheduler-alerts-report/scheduler-alerts-report.component";

export const ReportsRoutes: Routes = [
  {
    path: "reports",
    children: [
      { path: "schedule-alerts", component: SchedulerAlertsReportComponent },
    ],
  },
];
